import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const ZeroStateOpportunityProjects = () => {
    return (
        <>
            <Row>
                <br /><br /><br />
            </Row>

            <Row>
                <Col md={2}>
                </Col> 
                <Col md={8}>
                    <h1>Create your first Opportunity project</h1>
                </Col>
            </Row>

            <Row>
                <br />
            </Row>

            <Row>
                <Col md={2}>
                </Col>                
                <Col md={8}>
                    <h4>
                        Organize your Opportunity enrichment.  View your saved searches, opportunities, and related information all in one place.
                    </h4>
                </Col>                
            </Row>

            <Row>
                <br />
            </Row>

            {/* <Row>
                <Col md={2}>
                </Col>                
                <Col md={4}>
                    <div className='bg-primary-subtle p-5 rounded'>
                        <h1 className='text-center'>
                            <i className="bi bi-box"></i>
                        </h1>
                        <h3 className='text-center pt-2'>Single Item</h3>
                        <h5>For an item that you are sourcing a supplier for.  Useful for Capital expenditure projects.</h5>
                    </div>
                </Col>                
                <Col md={4}>
                <div className='bg-primary-subtle p-5 rounded'>
                        <h1 className='text-center'>
                            <i className="bi bi-boxes"></i>
                        </h1>
                        <h3 className='text-center pt-2'>Multiple Item</h3>
                        <h5>Will contain and track multiple items.  Useful for organizing BOMs. </h5>
                        <br />
                    </div>
                </Col>                
            </Row> */}

        </>
    );
};

export default ZeroStateOpportunityProjects;